module.exports = __webpack_public_path__ + "static/img/rank_60.de7c7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_60.png
// module id = t01w
// module chunks = 0